/**
 * Schémas Zod réutilisables.
 */

import { z } from "zod";

// Query HTTP : Boolean("false") vaut true. Le domaine choisit .optional()
// ou .default(false) ; les textes ambigus sont rejetés.
export const QueryBooleanSchema = z
  .union([z.boolean(), z.enum(["true", "false"])])
  .transform((value) => value === true || value === "true");

// UUID v4 (Postgres uuid)
export const UuidSchema = z.string().uuid();

// Email case-insensitive (la DB utilise citext)
export const EmailSchema = z
  .string()
  .email()
  .max(254)
  .transform((s) => s.toLowerCase().trim());

// Téléphone — souple (validation détaillée côté front via libphonenumber)
export const PhoneSchema = z
  .string()
  .min(7)
  .max(32)
  .regex(/^[\d\s().+\-x]+$/, "Format de téléphone invalide");

// Code postal canadien (avec ou sans espace)
export const PostalCASchema = z
  .string()
  .regex(/^[A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d$/, "Code postal invalide")
  .transform((s) => s.toUpperCase().replace(/[\s-]/g, ""));

// Date ISO yyyy-mm-dd
export const DateOnlySchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "Format attendu : YYYY-MM-DD");

// Slug (a-z, 0-9, tirets, 3-50 chars)
export const SlugSchema = z
  .string()
  .min(3)
  .max(50)
  .regex(/^[a-z][a-z0-9-]*[a-z0-9]$/, "Slug invalide (a-z, 0-9, tirets)");

// Locale supportée
export const LocaleSchema = z.enum(["fr", "en"]).default("fr");

// Argent (montant CAD, max 12 digits avant virgule, 2 après)
export const MoneySchema = z.number().nonnegative().max(999_999_999_999.99).multipleOf(0.01);

// Pagination
export const PaginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type Pagination = z.infer<typeof PaginationSchema>;
